<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper" style="z-index: 1065; transform: translate3d(440px, 300px, 0px); opacity: 1;">
			<div class="modal chatModal minWidth" style="width: 350px; height: 290px; display: block;">
				<div class="modalContent">
					<div class="chatWindow">
						<div class="chatControls">
							<div src="'tpl/chat/partials/chatRoomHeader.html'">
								<div class="chatHeader draggableHeader msAntiScroll" ng-class="{draggableHeader: !chatInfo.data.isDocked}" draggable="true">
									<div class="chat-room-member">
										<div class="chatMember clickable">
											<div class="playerBox">
												<div class="avatar-image playerAvatar" scale="0.45" player-id="178">
													<div class="heroImage male">
														<img src="//iwstatic.g.bsrv.su/resources/avatars/125/demon.png" width="56" height="56" />
													</div>
												</div>
											</div>
											<div class="chat-online-status chatStatus"></div>
											<div class="prestigeStars">
												<div class="innerStars">
													<i class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i>
												</div>
											</div>
										</div>
									</div>
									<a class="playerName playerLink truncated clickable">CMAPT</a>
									<div class="membership">
										<a class="kingdomLink truncated clickable disabled" ng-if="chatInfo.data.chatUser.data.kingdomId !== 0">АРМА</a>
									</div>
									<div class="flagHanger governor">
										<div class="flag"></div>
										<i class="community_governor_small_flat_black"></i>
									</div>
									<div class="controls">
										<i class="control clickable action_cancel_tiny_flat_black" on-pointer-over="cancelHover = true" on-pointer-out="cancelHover = false" clickable="closeChat()" tooltip="" tooltip-translate="Button.Close" ng-class="{action_cancel_tiny_flat_black: !cancelHover, action_cancel_tiny_flat_green: cancelHover}" @click="onModalClose(close)"></i>
										<i class="control clickable window_minimize_tiny_flat_black" on-pointer-over="minimizeHover = true" on-pointer-out="minimizeHover = false" clickable="minimizeChat()" tooltip="" tooltip-translate="Window.Minimize" ng-class="{window_minimize_tiny_flat_black: !minimizeHover, window_minimize_tiny_flat_green: minimizeHover}"></i>
										<i class="control clickable window_dock_tiny_flat_green" ng-if="!chatInfo.data.isDocked" on-pointer-over="dockHover = true" on-pointer-out="dockHover = false" clickable="dockChatWindow()" tooltip="" tooltip-translate="Window.Dock" ng-class="{window_dock_tiny_flat_black: !dockHover, window_dock_tiny_flat_green: dockHover}"></i>
									</div>
									<div class="options">
										<a class="iconButton clickable">
											<i class="symbol_arrowDown_tiny_illu"></i>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="unDockedChatBody">
							<div class="chat-window-body">
								<div class="chatBody scrollable" ng-if="room.chatRoom.data.joined !== 0">
									<div class="scrollContentOuterWrapper" style="width: 329px;">
										<div class="scrollContent" style="width: 329px; overflow-y: auto;">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<ul></ul>
											</div>
										</div>
									</div>
								</div>
								<div class="inputWrapper">
									<i class="chat_insert_message_small_flat writeMessage"></i>
									<span role="status" class="ui-helper-hidden-accessible"></span>
									<textarea class="chatInput ui-autocomplete-input" autocomplete="off" placeholder="Нажми здесь, чтобы ответить"></textarea>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="resizer restrictVertical window_resizehandle_small_illu"></div>
				<div class="resizeHelper" style="display: none;"></div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>